import IScenarioConfig from 'src/app/data/companyConfig/interfaces/IScenarioConfig';
import { ScenarioVersion, SoftwareType } from 'src/app/data/projects/interfaces/IProject';

export default function setInitialScenarioVersionFromConfig(value: ScenarioVersion | undefined, scenarioConfig: IScenarioConfig | null, setter: (scenarioVersion: ScenarioVersion, softwareType: SoftwareType) => void) {
  if (!value && scenarioConfig) {
    setter(scenarioConfig.defaultScenarioVersion, scenarioConfig.defaultSoftwareType);
  }
}
